import React, { useState } from 'react';
import { PaperPlaneTilt, ArrowsClockwise, SpinnerGap } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { resendAdhesionKit, checkAdhesionKitEmail } from '../../services/api';
import { EmailDeliveryStatus, emailDate, normalizeEmailStatus } from '../emails/EmailDeliveryStatus';

const LABELS = { unknown: 'Email : suivi indisponible', sending: 'Email : envoi en cours', accepted: 'Email : accepté par le service', delivered: 'Email : livré', rejected: 'Email : rejeté', failed: 'Email : échec de l’envoi', bounced: 'Email : rejeté par le destinataire', deferred: 'Email : livraison différée' };
export const KitEmailStatus = ({ kit }) => {
  const status = kit.email_delivery?.status || 'unknown';
  const delivery = kit.email_delivery || {};
  return <div className="mt-1 min-w-0 space-y-1">
    <EmailDeliveryStatus status={status} event={delivery.event} testId={`kit-email-status-${kit.id}`} />
    {delivery.event_at && <p className="text-xs text-gray-600" data-testid={`kit-email-event-${kit.id}`}>{emailDate(delivery.event_at)}</p>}
    {(status === 'deferred' || delivery.event === 'deferred') && <p className="text-xs text-amber-800" data-testid={`kit-email-deferred-${kit.id}`}>Livraison différée</p>}
    {delivery.tracking_warning && <p className="break-words text-xs text-amber-800" data-testid={`kit-email-warning-${kit.id}`}>{delivery.tracking_warning}</p>}
    {['failed', 'bounced', 'rejected'].includes(status) && delivery.error && <p className="break-words text-xs text-red-700" data-testid={`kit-email-reason-${kit.id}`}>{delivery.error}</p>}
  </div>;
};

export const KitEmailActions = ({ kit, onChanged }) => {
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const perform = async (resend) => {
    setBusy(true); setError('');
    try {
      const response = resend ? await resendAdhesionKit(kit.id) : await checkAdhesionKitEmail(kit.id);
      const delivery = response.data.email_delivery;
      if (resend) toast.success('Kit PDF transmis au service email');
      else if (delivery.tracking_warning) toast.warning(delivery.tracking_warning);
      else toast.message(LABELS[normalizeEmailStatus(delivery.status, delivery.event)] || LABELS.unknown);
      setConfirm(false);
      onChanged();
    } catch (e) {
      const message = e.response?.data?.detail || 'Le service email est indisponible.';
      setError(message); toast.error(message);
      onChanged();
    } finally { setBusy(false); }
  };
  return <>
    <Button size="sm" variant="ghost" disabled={busy || ['expired', 'cancelled'].includes(kit.status)} onClick={() => { setError(''); setConfirm(true); }} title="Renvoyer le kit par email" aria-label="Renvoyer le kit par email" data-testid={`resend-kit-${kit.id}`}>
      {busy ? <SpinnerGap className="animate-spin" size={16} /> : <PaperPlaneTilt size={16} />}
    </Button>
    {kit.email_delivery?.message_id && <Button size="sm" variant="ghost" disabled={busy} onClick={() => perform(false)} title="Vérifier la livraison de l'email" aria-label="Vérifier la livraison de l'email" data-testid={`check-kit-email-${kit.id}`}><ArrowsClockwise size={16} /></Button>}
    <Dialog open={confirm} onOpenChange={(open) => { if (!busy) setConfirm(open); }}>
      <DialogContent className="max-w-md" data-testid={`resend-kit-dialog-${kit.id}`}>
        <DialogHeader><DialogTitle>Renvoyer le kit d'adhésion ?</DialogTitle><DialogDescription data-testid={`resend-kit-recipient-${kit.id}`}>Le kit PDF sera envoyé à {kit.beneficiary?.email}.</DialogDescription></DialogHeader>
        {error && <p role="alert" className="text-sm text-red-700" data-testid={`resend-kit-error-${kit.id}`}>{error}</p>}
        <DialogFooter>
          <Button variant="outline" disabled={busy} onClick={() => setConfirm(false)} data-testid={`resend-kit-cancel-${kit.id}`}>Annuler</Button>
          <Button disabled={busy} onClick={() => perform(true)} data-testid={`resend-kit-confirm-${kit.id}`}>{busy ? 'Envoi en cours…' : 'Renvoyer le kit'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </>;
};